<template lang="pug">
v-flex 
  v-card
    v-card-title Transportistas
      v-spacer
      v-text-field(v-model='buscar_en_transportista' append-icon='fa-search' label='Buscar un transportista' single-line hide-details)
      v-dialog(v-model='transportista.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='limpiar_transportista()') Añadir
        v-card
          v-card-title
            span.headline Registro
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12 )
                  v-autocomplete(v-model='datos_transportista.tipo_de_transporte' label='Tipo' :items="lista_tipo_transporte" item-text='descripción' item-value='código')
                v-flex(xs12 )
                  v-text-field(v-model='datos_transportista.denominacion' label='Nombre' )
                v-flex(xs12  )
                  v-select(v-model='datos_transportista.documento_tipo' :items='documentTypesRecord' item-text='description' item-value='code' label='Tipo de documento')
                v-flex(xs12 )
                  v-text-field(v-model='datos_transportista.documento_numero' label='Documento' )
                v-flex(xs12 )
                  v-layout  
                    v-text-field(v-model='placa' label='Placas' )
                    v-btn( @click='agregar_placa(placa)') 
                      v-icon fas fa-plus
                  v-list
                    v-subheader Placas  
                    template(v-for='placa in datos_transportista.placas')
                      v-list-item
                        v-list-item-content 
                          v-list-item-title( v-text='placa' )
                        v-list-item-action(@click='eliminar_placa(placa)' )
                          v-icon(color='primary' small ) far fa-trash-alt
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='agregar_transportista()') Guardar
    v-data-table.elevation-1(:headers='encabezado_transportista' :items='Registro_de_transportistas' :search='buscar_en_transportista')
      template(v-slot:item.actions='{item}')
        td.justify-center.layout.px-0
          v-btn(color='secondary' icon @click='editar_transportistas(item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='borrar_transportista(item.key)')
            v-icon(small) far fa-trash-alt

  v-card
    v-card-title Conductores
      v-spacer
      v-text-field(v-model='buscar_en_conductores' append-icon='fa-search' label='Buscar un conductor' single-line hide-details)
      v-dialog(v-model='conductor.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='limpiar_conductor()') Añadir
        v-card
          v-card-title
            span.headline Título
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12 )
                    v-text-field(v-model='datos_conductor.conductor_denominacion' label='Nombre' )
                v-flex(xs12  )
                    v-select(v-model='datos_conductor.conductor_documento_tipo' :items='lista_de_documentos' item-text='label' item-value='value'  label='Tipo de documento')
                v-flex(xs12 )
                    v-text-field(v-model='datos_conductor.conductor_documento_numero' label='Documento' )    
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='agregar_conductor()') Guardar
    v-data-table.elevation-1(:headers='encabezado_conductores' :items='Registro_de_conductores' :search='buscar_en_conductores')
      template(v-slot:item.action='{item}')
       
        td.justify-center.layout.px-0
          v-btn(color='secondary' icon @click='editar_conductor(item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='editar_conductor(item.key)')
            v-icon(small) far fa-trash-alt
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import lista_de_documentos from '@/jsons/tipo_de_documento.json'
export default {
  data: () => ({
    buscar_en_transportista: '',
    buscar_en_conductores: '',
    placa: '',
    encabezado_transportista: [
      { text: 'Lista de transportistas', value: 'denominacion'},
      { text:'Tipo de documento', align: 'left', value: 'documento_tipo' },
      { text:'Documento', aling:'left', value:'documento_numero'},
      { text: '', value: 'actions', sortable: false }
    ],
    encabezado_conductores: [
      { text: 'Lista de conductores', value: 'conductor_denominacion' },
      { text:'Tipo de documento', value: 'conductor_documento_tipo'},
      { text:'Documento', value:'conductor_documento_numero'},
      { text: '', value: 'action', sortable: false }
    ],
    lista_tipo_transporte: [
      {
        código: "01",
        descripción: "TRANSPORTE PÚBLICO"
      },
      {
        código: "02",
        descripción: "TRANSPORTE PRIVADO"
      }

    ],
    lista_de_documentos,

  }),
    methods: {
      ...mapActions({
        editar_transportistas: 'Transportista/get',
        borrar_transportista: 'Transportista/clean',
        agregar_transportista: 'Transportista/add',
        limpiar_transportista: 'Transportista/clearForm',

        editar_conductor: 'Driver/get',
        borrar_conductor: 'Driver/clean',
        agregar_conductor: 'Driver/add',
        limpiar_conductor: 'Driver/clearForm',
      }),
      agregar_placa(placa){
          this.datos_transportista.placas.push(placa)
          this.placa = ''
      },
      eliminar_placa(placa){
        this.datos_transportista.placas.splice( this.datos_transportista.placas.indexOf(placa), 1)
        

    
      },
    },
    computed: {
      ...mapGetters({
        Registro_de_transportistas: 'Transportista/registro',
        documentTypesRecord: 'DocumentTypes/record',
        Registro_de_conductores: 'Driver/record',
      }),
       ...mapState({
      datos_transportista: state=> state.Transportista.datos,
      transportista :state=> state.Transportista,

      datos_conductor: state=> state.Driver.data,
      conductor :state=> state.Driver,
    })
  }
}
</script>
